import { useEffect, useState } from "react"
import { Link } from 'react-router-dom'
import { Input, Button, Table, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelecSupplier, SelectProductType } from "../../component/common/Selects"
import { DeleteButton } from "../../component/common/Buttons"
import { CheckImgs } from "../../component/common/Imgs"
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    supply_id: string | undefined
    goods_type_id: string | undefined
    goods_name: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        supply_id: undefined,
        goods_type_id: undefined,
        goods_name: undefined
    }

    const [userData, setUserData] = useState<any>({ user_name: '', is_admin: '' })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    const [swiperVisible, setSiperVisible] = useState<boolean>(false)
    const [urls, setUrls] = useState<string[]>([])

    useEffect(() => {
        let data: any = localStorage.getItem('userData')
        let d = JSON.parse(data)
        setUserData(d)

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/mall_center/spu/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 商城中心 -> 商品管理 -> 商品管理 */}
        <BreadCrumb position={['商城中心', '商品管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 5, marginBottom: 12 }}>
                    <SelecSupplier value={fetchOtherParams.supply_id} onChange={(v: string) => { handleChange(v, 'supply_id') }} />
                </div>
                <div style={{ marginRight: 5, marginBottom: 12 }}>
                    <SelectProductType value={fetchOtherParams.goods_type_id} onChange={(v: string) => { handleChange(v, 'goods_type_id') }} />
                </div>
                <Input style={{ marginRight: 5, marginBottom: 12, width: '180px' }} placeholder="商品名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'goods_name') }} value={fetchOtherParams.goods_name} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to="/product_add">添加</Link></Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm} >重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="商品名称" dataIndex="goods_name" key="goods_name" />
                <Column title="商品分类" dataIndex="goods_type_name" key="goods_type_name" />
                <Column title="供应商名称" dataIndex="supply_name" key="supply_name" />
                <Column title="商品品牌" dataIndex="brand_name" key="brand_name" />
                <Column title="商品产地" dataIndex="source_name" key="source_name" />
                <Column title="商品图片" dataIndex="goods_detail_pic_url" key="goods_detail_pic_url"
                    render={(v: any) => {
                        return <Button onClick={() => {
                            setUrls(v.split(','))
                            setSiperVisible(true)
                        }} size="small" >查看</Button>
                    }} />
                <Column title="商品单位" dataIndex="goods_unit" key="goods_unit" />
                <Column title="商品总库存" dataIndex="total_inventory_num" key="total_inventory_num" />
                <Column title="是否推荐" dataIndex="is_recommend" key="is_recommend" render={(v: any) => v === 1 ? '是' : '否'} />

                {userData.is_admin == 1 &&
                    <Column title="是否积分商品" dataIndex="is_points_goods" key="is_points_goods" render={(v: any) => v === 1 ? '是' : '否'} />
                }

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Link to={"/product_edit/" + record.id}>编辑</Link>
                            <DeleteButton url="/mall_center/spu/delete" record={record} cb={resetForm} />
                        </Space>
                    )}
                />
            </Table>
        </div>

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
    </div>)
}